import { useDashboard } from "@/context/dashboard";
import { Skeleton } from "@mui/material";
import Cookies from "js-cookie";
import Link from "next/link";
import { notFound } from "next/navigation";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

export default function DashboardHeader({ isTicketView, isSideBarOpen, setIsSideBarOpen }) {

    const router = useRouter();
    const [isActive, setIsActive] = useState(0);
    const [data, setData] = useState()
    const [loading, setLoading] = useState(false)
    const [appLink, setAppLink] = useState("")
    const { dsQuery, setDsQuery, loggedUserDetails, isUpdateProfileInfo, setIsUpdateProfileInfo } = useDashboard();

    useEffect(() => {
        setAppLink(getAppLink());
    }, []);

    const getAppLink = () => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        if (/android/i.test(userAgent)) {
            return "https://play.google.com/store/apps/details?id=com.qoncertapp.artist";
        } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return "https://apps.apple.com/us/app/qoncert-live-shows/id1537042846";
        } else if (/Macintosh|Mac OS X/.test(userAgent)) {
            return "https://apps.apple.com/us/app/qoncert-live-shows/id1537042846";
        } else {
            return "https://www.qoncertapp.com/";
        }
    };

    const fetchProfileInfo = async () => {

        if (!loggedUserDetails?.data?.web_token) {
            return;
        }

        try {
            setLoading(true);
            let web_token = loggedUserDetails.data.web_token;

            const formData = new FormData();
            formData.append("action", "fetchProfileInfo");

            const response = await fetch(`${process.env.NEXT_PUBLIC_BACKEND_URL}/webapi/manageUserData`, {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${web_token}`,
                },
                body: formData,
            });

            if (!response.ok) {
                notFound();
            }

            const data = await response.json();

            if (data.status) {
                setData(data.data);
                setIsUpdateProfileInfo(false)
            } else {
                console.error("Error fetching profile info");
            }
        } catch (error) {
            console.error("Error fetching profile info:", error);
        } finally {
            setLoading(false);
        }
    };

    const logout = async () => {
        try {
            let web_token = loggedUserDetails?.data?.web_token;
            const formData = new FormData();
            formData.append("action", "logout");

            const response = await fetch(`${process.env.NEXT_PUBLIC_BACKEND_URL}/webapi/manageUserData`, {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${web_token}`,
                },
                body: formData
            });

            const data = await response.json();

            if (data.status) {
                localStorage.clear();
                Cookies.remove("user_data")
                window.location.href = "/"
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };

    useEffect(() => {
        if (loggedUserDetails && isUpdateProfileInfo) {
            fetchProfileInfo();
        }
    }, [loggedUserDetails, isUpdateProfileInfo]);

    useEffect(() => {
        if (loggedUserDetails) {
            fetchProfileInfo();
        }
    }, [loggedUserDetails]);

    useEffect(() => {
        const path = router.pathname;
        if (path.includes("dashboard") || path.includes("tickets")) {
            setIsActive(0);
        } else if (path.includes("profile")) {
            setIsActive(1);
        } else if (path.includes("orders")) {
            setIsActive(4);
        } else {
            setIsActive(-1);
        }
    }, [router.pathname]);


    return (
        <div id="dashboard-header">
            <div className="hidden lg:block">
                <div className={`flex  items-center py-4 px-16 ${router.pathname.includes("profile") ? "justify-end" : "justify-between"}  ${!isTicketView && "bg-[#141414]"} `}>
                    <div className={`search-bar ${router.pathname.includes("profile") ? "hidden" : ""} h-fit w-fit ${isTicketView ? "hidden" : ""} ${isActive == 1 ? "opacity-0" : "opacity-100"} `}>
                        <input
                            className="dashboard-search w-[388px] rounded-[19px] outline-none "
                            type="search"
                            name=""
                            id=""
                            onChange={(e) => {
                                setDsQuery(e.target.value)
                            }}
                            value={dsQuery}
                            placeholder="Search"
                        />
                        <div className="serach-icon">
                            <svg
                                width="17"
                                height="16"
                                viewBox="0 0 17 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <g opacity="0.8">
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M9.69366 12.1833C12.4235 11.0036 13.696 7.79709 12.5358 5.02133C11.3757 2.24557 8.22221 0.951683 5.49237 2.13135C2.76253 3.31102 1.49005 6.51753 2.6502 9.29329C3.81036 12.0691 6.96382 13.3629 9.69366 12.1833Z"
                                        stroke="white"
                                        strokeWidth="1.2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M11.3904 11.0186L15.5557 15.2546"
                                        stroke="white"
                                        strokeWidth="1.2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </g>
                            </svg>
                        </div>
                    </div>
                    <Link href="/" className={`${!isTicketView ? "hidden" : " py-2 "}`}>
                        <img src={"/assets/logo.webp"} alt="qoncert" loading="eager" className="w-full h-full object-cover py-2 px-1" />
                    </Link>
                    <div className="profile-container min-w-[138px]">
                        {loading ? (
                            // Skeleton for profile image and text
                            <div className="flex gradient-skeleton items-center gap-5">
                                <Skeleton
                                    variant="circle"
                                    width="40px"
                                    height="40px"
                                    sx={{ margin: "0 auto", borderRadius: "9999999px" }}
                                />
                                <div className="flex flex-col">
                                    <Skeleton variant="text" width={60} height={22} />
                                    <Skeleton variant="text" width={70} height={22} />
                                </div>
                            </div>
                        ) : (
                            <div className="flex items-center gap-5">
                                <div>
                                    <div className="profile-image w-[44px] h-[44px] border-2 flex justify-center items-center bg-gray-400 border-white rounded-full overflow-hidden">
                                        {!data?.profile?.trim() ? (
                                            <div
                                                className="w-full h-full flex justify-center items-center text-white text-lg font-bold"
                                                style={{
                                                    background: "linear-gradient(92.34deg, #fa2cb4 6.54%, #bc17d9 52.63%, #7f03ff 109.97%)",
                                                }}
                                            >
                                                {data?.name?.charAt(0)?.toUpperCase() ?? "U"}
                                            </div>
                                        ) : (
                                            <img
                                                src={data.profile}
                                                className="object-cover w-full h-full"
                                                alt="Profile"
                                            />
                                        )}
                                    </div>

                                </div>
                                <div className="profile-text min-w-max">
                                    {data?.name} <br /> {data?.city || "Denver"}, {data?.state || "CO"}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className="lg:hidden">
                <div className="flex py-4 justify-between items-center px-7">
                    {!isTicketView ? (
                        <p
                            onClick={() => {
                                setIsSideBarOpen(true);
                            }}
                        >
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M3.59961 6.00078C3.59961 5.33804 4.13687 4.80078 4.79961 4.80078H19.1996C19.8624 4.80078 20.3996 5.33804 20.3996 6.00078C20.3996 6.66352 19.8624 7.20078 19.1996 7.20078H4.79961C4.13687 7.20078 3.59961 6.66352 3.59961 6.00078Z"
                                    fill="white"
                                />
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M3.59961 12.0008C3.59961 11.338 4.13687 10.8008 4.79961 10.8008H19.1996C19.8624 10.8008 20.3996 11.338 20.3996 12.0008C20.3996 12.6635 19.8624 13.2008 19.1996 13.2008H4.79961C4.13687 13.2008 3.59961 12.6635 3.59961 12.0008Z"
                                    fill="white"
                                />
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M10.7996 18.0008C10.7996 17.338 11.3369 16.8008 11.9996 16.8008H19.1996C19.8624 16.8008 20.3996 17.338 20.3996 18.0008C20.3996 18.6635 19.8624 19.2008 19.1996 19.2008H11.9996C11.3369 19.2008 10.7996 18.6635 10.7996 18.0008Z"
                                    fill="white"
                                />
                            </svg>
                        </p>
                    ) : (
                        <p onClick={() => {
                            navigate(-1)
                        }}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15 19L8 12L15 5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </p>
                    )}
                    <div className="border-2 border-white rounded-full w-[30px] aspect-square overflow-hidden">
                        <img
                            className="w-full h-full object-cover"
                            alt=""
                            src={data?.profile ?? "/assets/usr.webp"}
                        />
                    </div>
                </div>
            </div>
            {isSideBarOpen && (
                <div className="min-h-screen p-7 flex flex-col relative z-[9] max-w-[85%] rounded-[20px] -mt-[62px] bg-[#1F222A] ">
                    <div className="flex justify-between items-center">
                        <div>
                            <img onClick={() => router.push("/")} className=" max-w-[101px] object-cover " src={"/assets/logo.webp"} alt="" />
                        </div>
                        <div onClick={() => setIsSideBarOpen(false)}>
                            <svg
                                width="35"
                                height="35"
                                viewBox="0 0 35 35"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <rect width="35" height="35" rx="17.5" fill="#1F222A" />
                                <path
                                    d="M11.144 24L16.496 17.352V18.552L11.456 12.288H14.288L17.864 16.848H17L20.576 12.288H23.408L18.368 18.504V17.424L23.72 24H20.84L17 19.152H17.816L14 24H11.144Z"
                                    fill="#9CA0A6"
                                />
                            </svg>
                        </div>
                    </div>
                    <div className="mt-16 px-[1px]">
                        <div className="flex flex-col gap-5">
                            <Link
                                href="/dashboard"
                                className={`pt-4 pb-5 w-full text-xl font-[700] font-urbanist pl-14 hover:bg-[#252933] rounded-[4px] ${isActive == 0 ? "bg-[#252933]" : ""
                                    }`}
                            >
                                Tickets
                            </Link>
                            <Link
                                href="/orders"
                                className={`pt-4 pb-5 w-full text-xl font-[700] font-urbanist pl-14 hover:bg-[#252933] rounded-[4px] ${isActive == 4 ? "bg-[#252933]" : ""
                                    }`}
                            >
                                Orders
                            </Link>
                            <Link
                                href="/shows"
                                className={`pt-4 pb-5 w-full text-xl font-[700] font-urbanist pl-14 hover:bg-[#252933] rounded-[4px] ${isActive == 2 ? "bg-[#252933]" : ""
                                    }`}
                            >
                                Shows
                            </Link>
                            <Link
                                href="/profile"
                                className={`pt-4 pb-5 w-full text-xl font-[700] font-urbanist pl-14 hover:bg-[#252933] rounded-[4px] ${isActive == 1 ? "bg-[#252933]" : ""
                                    }`}
                            >
                                Profile
                            </Link>
                        </div>
                    </div>
                    <div className="flex-grow"></div>
                    <a
                        href={appLink}
                        target="_blank"
                        className="w-full mx-1 bg-white py-[17px] leading-[17px] font-[700] text-center rounded-xl text-black "
                    >
                        GET THE APP
                    </a>
                    <div onClick={logout} className="mt-[60px] text-xl font-[600] ml-[50px] leading-[20px] ">Log Out</div>
                </div>
            )}
        </div>
    )
}